module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.77be2b6e.mp3";